module.exports = __webpack_public_path__ + "img/ranking-top-img.552549ca.png";